/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CodeIcon = ({ width = 24, height = 24, hidden = false, title = 'Code' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m35.493 19.061-8.193 8.32a1 1 0 0 1-1.425 0l-.893-.907a1.006 1.006 0 0 1 0-1.4L31.943 18l-6.959-7.071a1.006 1.006 0 0 1 0-1.4l.893-.907a1 1 0 0 1 1.425 0l8.191 8.32a1.523 1.523 0 0 1 0 2.119ZM.507 16.939 8.7 8.619a1 1 0 0 1 1.425 0l.893.907a1.006 1.006 0 0 1 0 1.4L4.057 18l6.959 7.071a1.006 1.006 0 0 1 0 1.4l-.893.907a1 1 0 0 1-1.425 0L.507 19.061a1.523 1.523 0 0 1 0-2.122ZM15.489 29.687h-1.144a1 1 0 0 1-.966-1.259l6.192-23.041a1 1 0 0 1 .966-.741h1.105a1 1 0 0 1 .966 1.254l-6.153 23.046a1 1 0 0 1-.966.741Z"
    />
  </svg>`;
};
